// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22ACJ","title":"styles_title__245_Y"};